
export default {
  props: {
    offer: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    partner: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data () {
    return {
      shareActive: false,
    };
  },
  computed: {
    offerLink () {
      return this.offer.offer_link !== `` ? this.offer.offer_link : this.partner.slug;
    },
    imageSrc () {
      return this.siteSettings?.boa_offers_fallback_image?.sizes.large;
    },
    imageSrcset () {
      return this.siteSettings?.boa_offers_fallback_image?.sizes.large;
    },
    imageTitle () {
      return this.siteSettings?.boa_offers_fallback_image?.alt;
    },
    excerptLength () {
      return this.$store.state.config.excerpt_lengths.news_card;
    },
    socialShareDetails () {
      return {
        link: this.offer.offer_link,
        title: this.offer.offer_title,
      };
    },
  },
};
